/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * SOFT_DELETE_STANDARD — retención de papelera: los elementos de catálogo
 * soft-borrados se purgan físicamente tras este nº de días (el job servidor
 * `TRASH_PURGE_DAYS`, con `0` = desactivado). La UI de papelera lo usa para el
 * contador «se eliminará definitivamente en N días».
 */
export const TRASH_PURGE_DAYS = 30;

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "comandero";
export const APP_DOMAIN = "app.listto.com";
